import { render, staticRenderFns } from "./ColumnElement.vue?vue&type=template&id=592c20fd&scoped=true&lang=html"
import script from "./ColumnElement.vue?vue&type=script&lang=js"
export * from "./ColumnElement.vue?vue&type=script&lang=js"
import style0 from "./ColumnElement.vue?vue&type=style&index=0&id=592c20fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592c20fd",
  null
  
)

export default component.exports